import { CustomerType, DiscountType } from '@repo/common';
import { z } from 'zod';

export const AddToCartSchema = z.object({
    purchase_id: z.string(),
    quantity: z.string(),
    type: z.string(),
    price: z.string(),
});

export type AddToCart = z.infer<typeof AddToCartSchema>;

export const ResponseCartListItemSchema = z.object({
    id: z.string(),
    user_id: z.string(),
    product_name: z.string(),
    batch_id: z.string(),
    draft_note: z.string().optional().nullable(),
    quantity: z.coerce.number().positive(),
    price: z.coerce.number().positive(),
    discount_type: z.string().optional().nullable(),
    discount_value: z.coerce.number(),
    discounted_price: z.coerce.number(),
    total_price: z.coerce.number().optional(),
});

export const ResponseDraftListItemSchema = z.object({
    id: z.string(),
    user_id: z.string(),
    customer_id: z.string().optional().nullable(),
    customer_type: z.nativeEnum(CustomerType),
    draft_note: z.string().optional().nullable(),
    discount_type: z.string().optional().nullable(),
    discount_value: z.number(),
    note: z.string().optional().nullable(),
    tax: z.number(),
    items: z.array(ResponseCartListItemSchema),
});

export const ResponseCartInfoSchema = z.object({
    id: z.string(),
    user_id: z.string(),
    customer_id: z.string().optional().nullable(),
    discount_type: z.nativeEnum(DiscountType).optional().nullable(),
    discount_value: z.coerce.number(),
    tax: z.number(),
    draft_note: z.string().optional().nullable(),
    note: z.string().optional().nullable(),
    customer_type: z.nativeEnum(CustomerType).optional(),
    customer: z
        .object({
            id: z.string(),
            serial_id: z.number(),
            name: z.string(),
            email: z.string().optional().nullable(),
            phone_number: z.string().optional().nullable(),
            customer_type: z.nativeEnum(CustomerType),
        })
        .nullable()
        .optional(),
    total_price: z.coerce.number(),
    sub_total_price: z.coerce.number(),
    individual_discount: z.coerce.number(),
});
export const ResponseCartListSchema = z.object({
    data: z.object({
        items: z.array(ResponseCartListItemSchema),
        info: ResponseCartInfoSchema,
    }),
});

export const ResponseDraftListSchema = z.object({
    data: z.array(ResponseDraftListItemSchema),
});

export type CartListItem = z.infer<typeof ResponseCartListItemSchema>;
export type DraftList = z.infer<typeof ResponseDraftListSchema>;
export type DraftListItem = z.infer<typeof ResponseDraftListItemSchema>;
export type CartList = z.infer<typeof ResponseCartListSchema>;
export type CartInfo = z.infer<typeof ResponseCartInfoSchema>;
